export default __webpack_public_path__ + "static/media/S3xCLUE1.d2db4317.jpg";